import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { useMerchantId } from '@/hooks/useMerchantId';

/** FR-64: `/merchant` returns the caller's own merchant directly. */
export function useMerchant() {
  const { merchantId } = useMerchantId();
  return useQuery({
    queryKey: ['merchant', merchantId],
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/merchant');
      if (error) throw error;
      return data?.data ?? null;
    },
    enabled: !!merchantId,
  });
}
